import styled, { css } from 'styled-components';

import { styledReset, styledTypography } from '@pkg/primitives';

import { CompetitionCollectionStatus } from '@app/client';

export const ListTable = styled.div<{ $headers?: boolean }>`
    display: grid;
    grid-template-columns: 2fr 1fr;
    align-items: flex-end;
    padding: 6px 4px 0;

    &:hover {
        opacity: 0.7;
    }

    ${({ $headers }) =>
        $headers &&
        css`
            border-bottom: 1px solid white;
        `}
`;

export const Header = styled.h2<{ $isSort?: boolean; $isDesc?: boolean }>`
    ${styledTypography.allianceBase};
    font-size: 22px;
    font-weight: 700;
    padding: 8px;
    position: relative;
    svg {
        position: absolute;
        opacity: 0.6;
        width: 33px;
        right: -45px;
        top: 0;
    }

    :before {
        content: '';
        position: absolute;
        right: 45px;
        bottom: 8px;
        width: 5px;
        height: 10px;
        opacity: ${({ $isSort }) => ($isSort ? 1 : 0)};

        border-color: transparent;
        border-top-color: #ffffff;
        border-style: solid;

        border-width: 0 0.4em 0.6em;
        border-bottom-color: #ffffff;
        ${({ $isDesc }) =>
            $isDesc &&
            css`
                transform: rotate(180deg);
            `}
    }

    ${({ $isSort }) =>
        $isSort &&
        css`
            cursor: pointer;
            &:hover {
                opacity: 0.8;
            }
        `}
`;

export const CollectionSlug = styled.a.attrs({
    target: '_blank',
    rel: 'noopener noreferrer',
})<{ $status?: string }>`
    ${styledReset.link};
    ${styledTypography.allianceBase};
    font-weight: 400;

    ${({ $status }) => {
        switch ($status) {
            case CompetitionCollectionStatus.Banned: {
                return css`
                    color: ${({ theme }) => theme.shades.red[90]};
                    &:visited {
                        color: ${({ theme }) => theme.shades.red[90]};
                    }
                `;
            }
            case CompetitionCollectionStatus.UnderInvestigation: {
                return css`
                    color: ${({ theme }) => theme.shades.purpleLight[90]};
                    &:visited {
                        color: ${({ theme }) => theme.shades.purpleLight[90]};
                    }
                `;
            }
            case CompetitionCollectionStatus.Normal:
            default: {
                return css`
                    color: ${({ theme }) => theme.shades.white[80]};
                    &:visited {
                        color: ${({ theme }) => theme.shades.white[80]};
                    }
                `;
            }
        }
    }}
`;

export const CollectionStatus = styled.p`
    ${styledTypography.allianceBase};
    font-weight: 400;
`;
